export default __webpack_public_path__ + "static/media/callsLight.bbfe48d1.svg";